import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import Modal from '../../../webcommon/common/modal/Modal';
import defaultStyles from './TradePricedToday.module.scss';
import TradePricedHeader from './tradepricedheader/TradePricedHeader';
import { tradesSelectedAreDifferent } from '../../../common/helpermethods/HelperMethods';
import TradeTable from './tradetable/TradeTable';
import TradePricedFooter from './tradepricedfooter/TradePricedFooter';
import BookTradesModal from './processtradesmodal/ProcessTradesModal';

const filterTrades = (filterString, trades) => (
    trades.filter(trade => trade.name.includes(filterString))
);

const TradePricedTodayView = (props) => {
    const changesInTradeSelection = useMemo(() => tradesSelectedAreDifferent(
        props.trades, props.originalTrades
    ), [props.trades, props.originalTrades]);

    const memoizedTradesByFilter = useMemo(() => filterTrades(
        props.searchString, props.trades
    ), [props.searchString, props.trades]);

    const numberOfTrades = useMemo(() => props.stateTrades
        .filter(trade => !trade.booked && trade.confirmed).length,
    [props.stateTrades]);

    const memoizedSelectedTrades = useMemo(() => props.stateTrades
        .filter(trade => !trade.booked && trade.visible),
    [props.stateTrades]);

    return (
        <div className={ props.styles.tradePricedTodayWrapper }>
            <TradePricedHeader
                changesInTradeSelection={ changesInTradeSelection }
                searchValue={ props.searchString }
                setTradeSearchString={ props.setSearchString }
                readOnly={ props.readOnly }
            />
            <TradeTable
                openBookTradesModal={ props.openSingleTradeModal }
                openDeleteTradesModal={ props.openSingleDeleteTradesModal }
                setTradeChecked={ props.setTradeChecked }
                setTradeCheckedId={ props.setTradeCheckedId }
                trades={ memoizedTradesByFilter }
                tradeIdTicked={ props.tradeIdTicked }
                openUnbookTradesModal={ props.openUnbookTradesModal }
                viewTradeInPricingParams={ props.viewTradeInPricingParams }
                readOnly={ props.readOnly }
            />
            { !props.readOnly && (
                <TradePricedFooter
                    bookSelectedTrades={ props.openBookTradesModal }
                    deleteSelectedTrades={ props.openDeleteTradesModal }
                    trades={ props.trades }
                />
            )}
            <Modal
                closeModal={ props.closeModal }
                isOpen={ props.modalIsOpen }
            >
                <BookTradesModal
                    cancelModal={ props.closeModal }
                    numberOfTrades={ numberOfTrades }
                    process={ props.process }
                    submitModal={ props.submitModal }
                    submitDeleteTradesModal={ props.submitDeleteTradesModal }
                    submitUnbooKTradesModal={ props.submitUnbooKTradesModal }
                    toggleTrade={ props.toggleTrade }
                    trades={ memoizedSelectedTrades }
                />
            </Modal>
        </div>
    );
};

TradePricedTodayView.propTypes = {
    closeModal: PropTypes.func,
    modalIsOpen: PropTypes.bool,
    openBookTradesModal: PropTypes.func,
    openSingleDeleteTradesModal: PropTypes.func,
    openSingleTradeModal: PropTypes.func,
    openUnbookTradesModal: PropTypes.func,
    originalTrades: PropTypes.arrayOf(PropTypes.shape({})),
    openDeleteTradesModal: PropTypes.func,
    process: PropTypes.string,
    searchString: PropTypes.string,
    setSearchString: PropTypes.func,
    setTradeChecked: PropTypes.func,
    setTradeCheckedId: PropTypes.func,
    stateTrades: PropTypes.arrayOf(PropTypes.shape({})),
    styles: PropTypes.objectOf(PropTypes.string),
    submitDeleteTradesModal: PropTypes.func,
    submitModal: PropTypes.func,
    submitUnbooKTradesModal: PropTypes.func,
    toggleTrade: PropTypes.func,
    tradeIdTicked: PropTypes.bool,
    trades: PropTypes.arrayOf(PropTypes.shape({})),
    viewTradeInPricingParams: PropTypes.func,
    readOnly: PropTypes.bool
};

TradePricedTodayView.defaultProps = {
    closeModal: noop,
    modalIsOpen: false,
    process: '',
    openBookTradesModal: noop,
    openDeleteTradesModal: noop,
    openSingleDeleteTradesModal: noop,
    openSingleTradeModal: noop,
    openUnbookTradesModal: noop,
    originalTrades: [],
    searchString: '',
    setSearchString: noop,
    setTradeChecked: noop,
    setTradeCheckedId: noop,
    stateTrades: [],
    styles: defaultStyles,
    submitDeleteTradesModal: noop,
    submitModal: noop,
    submitUnbooKTradesModal: noop,
    toggleTrade: noop,
    tradeIdTicked: false,
    trades: [],
    viewTradeInPricingParams: noop,
    readOnly: false
};

export default TradePricedTodayView;
